const EmptyResults = (props)=>{
    return(
        <div className="message">
            <div className="message__icon">
                <img loading="lazy" src={'/assets/images/search_icon.svg'} width="96" alt="magnifier icon" height="96"/>
            </div>
            <div className="message__content">
                <h2 className="message__title">{props.localization.notFoundTitle}</h2>
                <div className="message__text">
                {props.localization.notFoundText} <a href={props.localization.notFoundLinkUrl} target="_blank" rel="noopener noreferrer" className="link"> {props.localization.notFoundLinkText}</a> 
                </div>
            </div>
        </div>
    )
}
export default EmptyResults